export interface AspenFeaturesState {
  assist: boolean;
  guardian: boolean;
  recordInstructionFiles: boolean;
  forwardCwes: boolean;
  adapt: boolean;
  recordRepoName: boolean;
  recordUsername: boolean;
  recordPrNumber: boolean;
}

export type AspenFeatureKey = keyof AspenFeaturesState;
export type AspenTopLevelFeatureKey = "assist" | "guardian" | "adapt";

export const ASPEN_FEATURE_META: Record<AspenFeatureKey, { group: string; field: string }> = {
  assist: { group: "aspen.assist", field: "hintsEnabled" },
  guardian: { group: "aspen.guardian", field: "enableAspenGuardian" },
  recordInstructionFiles: { group: "aspen.guardian", field: "recordInstructionFiles" },
  forwardCwes: { group: "aspen.guardian", field: "forwardCwes" },
  adapt: { group: "aspen.adapt", field: "enableAspenAdapt" },
  recordRepoName: { group: "aspen.adapt", field: "recordRepoName" },
  recordUsername: { group: "aspen.adapt", field: "recordUsername" },
  recordPrNumber: { group: "aspen.adapt", field: "recordPrNumber" },
};

export const ALL_ASPEN_FEATURES_DISABLED: AspenFeaturesState = {
  assist: false,
  guardian: false,
  recordInstructionFiles: false,
  forwardCwes: false,
  adapt: false,
  recordRepoName: false,
  recordUsername: false,
  recordPrNumber: false,
};

export const DEFAULT_ASPEN_REENABLE_SNAPSHOT: Record<AspenTopLevelFeatureKey, boolean> = {
  assist: true,
  guardian: true,
  adapt: true,
};

export const getAspenSnapshotStorageKey = (tenantName: string) =>
  `aspen-features-snapshot:${tenantName}`;

export const getAspenTopLevelSnapshot = (
  features: AspenFeaturesState
): Record<AspenTopLevelFeatureKey, boolean> => ({
  assist: features.assist,
  guardian: features.guardian,
  adapt: features.adapt,
});

export const areAspenTopLevelFeaturesDisabled = (features: AspenFeaturesState) =>
  !features.assist && !features.guardian && !features.adapt;
